var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeze(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 457.9 512",
    style: {
      enableBackground: "new 0 0 457.9 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425,0H134v15.2h291c9.8,0,17.7,8,17.7,17.7v363.2H15.2V33c0-9.8,8-17.7,17.7-17.7h80.8V0H33C14.8,0,0,14.8,0,33v363.2 v79.4v0.1h27V512h403.9v-36.4h27v-0.1v-79.4V33C457.9,14.8,443.2,0,425,0z M442.7,460.3h-27v0.1H99.8v15.2h315.9v21.2H42.2v-21.2 h39.5v-15.2H42.2v-0.1h-27v-49h427.5V460.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.3,
    y: 98.9,
    width: 15.2,
    height: 79.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.3,
    y: 198.9,
    width: 15.2,
    height: 184.6
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.3,130.8 78.3,115.6 40.6,115.6 40.6,295.8 78.3,295.6 78.2,280.4 55.8,280.5 55.8,130.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.6,213.3 210.6,213.3 190.1,233.7 162.4,233.7 162.4,249 185.7,248.9 185.7,272.2 200.9,272.2 200.9,244.5  221.4,224 221.4,285 236.6,285 236.6,224 257,244.5 257,272.2 272.2,272.2 272.2,249 295.5,248.9 295.5,233.7 267.8,233.7  247.3,213.3 308.3,213.3 308.3,198.1 247.3,198.1 267.8,177.6 295.5,177.6 295.5,162.4 272.2,162.4 272.2,139.1 257,139.1  257,166.9 236.6,187.3 236.6,126.4 221.4,126.4 221.4,187.3 200.9,166.9 200.9,139.1 185.7,139.1 185.7,162.4 162.4,162.4  162.4,177.6 190.1,177.6 210.6,198.1 149.6,198.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 422.9,
    width: 15.2,
    height: 25.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.9,
    y: 422.9,
    width: 15.2,
    height: 25.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.3,
    y: 422.9,
    width: 15.2,
    height: 25.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.4,
    y: 422.9,
    width: 15.2,
    height: 25.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.8,
    y: 422.9,
    width: 15.2,
    height: 25.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.2,
    y: 422.9,
    width: 15.2,
    height: 25.9
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeze);
export default __webpack_public_path__ + "static/media/freeze.d6a837f50904466ce282465c6f3a8bcb.svg";
export { ForwardRef as ReactComponent };